const lookups = {
  account: {
    all: { name: "Account", entityName: "account" },
    attributes: {
      name: "Account Attributes",
      entityName: "account",
      method: "GetEntityAttributes?entityname=account",
      mapData: (attribute) => ({
        Key: attribute.Name,
        Value: attribute.DisplayName,
      }),
    },
    contact: {
      name: "Account Contacts",
      entityName: "accountcontacts",
    },
  },
  campaign: {
    all: { name: "Reporting Campaigns", entityName: "campaign" },
  },
  contact: {
    all: { name: "Contacts", entityName: "contact" },
    attributes: {
      name: "Contact Attributes",
      entityName: "contact",
      method: "GetEntityAttributes?entityname=contact",
      mapData: (attribute) => ({
        Key: attribute.Name,
        Value: attribute.DisplayName,
      }),
    },
  },
  customeraddress: {
    all: { name: "CustomerAddresses", entityName: "customeraddress" },
  },
  g4c_abtest: {
    all: {
      name: "A/B Tests",
      entityName: "g4c_abtest",
    },
  },
  g4c_communication: {
    all: {
      name: "Email Communications",
      entityName: "g4c_communication",
    },
    abtest: {
      name: "Email Communications for A/B Tests",
      entityName: "g4c_communication",
      searchFilter: "abtest",
    },
    contactFlow: {
      name: "Contact Automation Communications",
      entityName: "g4c_communication",
      method: "GetFlowCommunications?type=contact",
      mapData: (communication) => ({
        Key: communication.Id,
        Value: communication.Name,
        StatusCode: communication.StatusCode,
      }),
    },
  },
  g4c_communicationactivity: {
    all: {
      name: "Communication Activities",
      entityName: "g4c_communicationactivity",
    },
  },
  g4c_communicationaudience: {
    all: {
      name: "Audiences",
      entityName: "g4c_communicationaudience",
      method: "GetCommunicationAudiences",
      mapData: (audience) => ({
        Key: audience.Id,
        Value: audience.Name,
        RunAt: audience.RunAt,
        Type: audience.Type,
      }),
    },
  },
  g4c_communicationaudit: {
    all: {
      name: "Communication Audits",
      entityName: "g4c_communicationaudit",
    },
  },
  g4c_communicationsavedlayout: {
    all: {
      name: "Communication Saved Layouts",
      entityName: "g4c_communicationsavedlayout",
    },
  },
  g4c_subscriptiongroup: {
    all: {
      name: "Email Preference Groups",
      entityName: "g4c_subscriptiongroup",
    },
  },
  g4c_triggerflow: {
    all: {
      name: "Flows",
      entityName: "g4c_triggerflow",
    },
  },
  g4gdpr_contactaudit: {
    all: {
      name: "Contact Audits",
      entityName: "g4gdpr_contactaudit",
    },
  },
  g4gdpr_subscriptionaudit: {
    all: {
      name: "Subscription Audits",
      entityName: "g4gdpr_subscriptionaudit",
    },
  },
  list: {
    all: { name: "Static Marketing Lists", entityName: "list" },
  },
  listmember: {
    all: {
      name: "Static Marketing List Members",
      entityName: "listmember",
    },
  },
  savedview: {
    all: {
      name: "Saved Views",
      entityName: "savedview",
      method: "GetSavedViews",
      mapData: (view) => ({
        Key: view.Id,
        Value: view.Name,
        EntityName: view.EntityName,
      }),
    },
  },
  dwcommpage: {
    all: {
      name: "Data Warehouse Communication Pages",
      entityName: "dwcommpage",
    },
  },
  entityaudit: {
    all: {
      name: "Entity Audits",
      entityName: "entityaudit",
    },
  },
  dwcommunication: {
    all: {
      name: "Data Warehouse Communications",
      entityName: "dwcommunication",
    },
  },
  dwcommunicationcampaign: {
    all: {
      name: "Data Warehouse Communication Campaigns",
      entityName: "dwcommunicationcampaign",
    },
  },
  dwautomation: {
    all: {
      name: "Data Warehouse Automations",
      entityName: "dwautomation",
    },
  },
  dwcompetition: {
    all: {
      name: "Data Warehouse Competitions",
      entityName: "dwcompetition",
    },
  },
  dwcompetitionstage: {
    all: {
      name: "Data Warehouse Competition Stages",
      entityName: "dwcompetitionstage",
    },
  },
  dwcountry: {
    all: {
      name: "Data Warehouse Countries",
      entityName: "dwcountry",
    },
  },
  dwdatamodel: {
    all: {
      name: "Data Warehouse Data Models",
      entityName: "dwdatamodel",
    },
  },
  dwdatasource: {
    all: {
      name: "Data Warehouse Data Sources",
      entityName: "dwdatasource",
    },
  },
  dweventprofile: {
    all: {
      name: "Data Warehouse Event Profiles",
      entityName: "dweventprofile",
    },
  },
  dweventteam: {
    all: {
      name: "Data Warehouse Event Teams",
      entityName: "dweventteam",
    },
  },
  dweventtype: {
    all: {
      name: "Data Warehouse Event Types",
      entityName: "dweventtype",
    },
  },
  dwfixture: {
    all: {
      name: "Data Warehouse Fixtures",
      entityName: "dwfixture",
    },
  },
  dwfixturegrade: {
    all: {
      name: "Data Warehouse Fixture Grades",
      entityName: "dwfixturegrade",
    },
  },
  dwhomestatus: {
    all: {
      name: "Data Warehouse Home Statuses",
      entityName: "dwhomestatus",
    },
  },
  dwimports: {
    all: {
      name: "Data Warehouse Imports",
      entityName: "dataimport",
    },
  },
  dwmembership: {
    all: {
      name: "Data Warehouse Memberships",
      entityName: "dwmembership",
    },
  },
  dwopponent: {
    all: {
      name: "Data Warehouse Opponents",
      entityName: "dwopponent",
    },
  },
  dwopponenttype: {
    all: {
      name: "Data Warehouse Opponent Types",
      entityName: "dwopponenttype",
    },
  },
  dwretailproductcategory1: {
    all: {
      name: "Data Warehouse Retail Product Categories 1",
      entityName: "dwretailproductcategory1",
    },
  },
  dwretailproductcategory2: {
    all: {
      name: "Data Warehouse Retail Product Categories 2",
      entityName: "dwretailproductcategory2",
    },
  },
  dwretailproductcategory3: {
    all: {
      name: "Data Warehouse Retail Product Categories 3",
      entityName: "dwretailproductcategory3",
    },
  },
  dwseason: {
    all: {
      name: "Data Warehouse Seasons",
      entityName: "dwseason",
    },
  },
  dwseasonalperiod: {
    all: {
      name: "Data Warehouse Seasonal Periods",
      entityName: "dwseasonalperiod",
    },
  },
  dwseasonname: {
    all: {
      name: "Data Warehouse Season Names",
      entityName: "dwseasonname",
    },
  },
  dwsegmentgroup1: {
    all: {
      name: "Data Warehouse Segment Groups 1",
      entityName: "dwsegmentgroup1",
    },
  },
  dwsegmentgroup2: {
    all: {
      name: "Data Warehouse Segment Groups 2",
      entityName: "dwsegmentgroup2",
    },
  },
  dwsegmentgroup3: {
    all: {
      name: "Data Warehouse Segment Groups 3",
      entityName: "dwsegmentgroup3",
    },
  },
  dwsources: {
    all: {
      name: "Data Warehouse Sources",
      entityName: "warehouse_sources",
      method: "GetWarehouseSources",
      mapData: (source) => ({
        Key: source.ClientId,
        Value: source.Label,
      }),
    },
  },
  dwsubscriptionproduct: {
    all: {
      name: "Data Warehouse Subscription Products",
      entityName: "dwsubscriptionproduct",
    },
  },
  dwsubscriptionsource: {
    all: {
      name: "Data Warehouse Subscription Sources",
      entityName: "dwsubscriptionsource",
    },
  },
  dwsubscriptiontype: {
    all: {
      name: "Data Warehouse Subscription Types",
      entityName: "dwsubscriptiontype",
    },
  },
  dwteam: {
    all: {
      name: "Data Warehouse Teams",
      entityName: "dwteam",
    },
  },
  dwticketproduct: {
    all: {
      name: "Data Warehouse Ticket Products",
      entityName: "dwticketproduct",
    },
  },
  dwticketproducttype: {
    all: {
      name: "Data Warehouse Ticket Product Types",
      entityName: "dwticketproducttype",
    },
  },
  dwticketseatarea: {
    all: {
      name: "Data Warehouse Ticket Seat Areas",
      entityName: "dwticketseatarea",
    },
  },
  dwticketseatblock: {
    all: {
      name: "Data Warehouse Ticket Seat Blocks",
      entityName: "dwticketseatblock",
    },
  },
  dwtickethospitalityproduct: {
    all: {
      name: "Data Warehouse Ticket Hospitality Product",
      entityName: "dwtickethospitalityproduct",
    },
  },
  systemuser: {
    all: { name: "System Users", entityName: "systemuser" },
  },
  dwtype: {
    all: {
      name: "Data Warehouse Types",
      entityName: "dwtype",
    },
  },
};

export default lookups;
